export default __webpack_public_path__ + "static/media/florida.d5d16200.jpg";